<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row" [formGroup]="formGroup">
  <label class="control-label" *ngIf="showLabel">
    <span *ngIf="!label" i18n="@@paymentType">Payment type</span>
    <span *ngIf="label">{{label}}</span>&nbsp;<span *ngIf="showRequired && required">*</span>
  </label>

  <mat-radio-group class="radio-group-vertical" [formControlName]="controlName">
    <mat-radio-button class="radio-button-vertical" color="primary" *ngFor="let d of data" [value]="d?.id">
      {{d?.tag}}
    </mat-radio-button>
  </mat-radio-group>

  <div *ngIf="showInvalid" class="invalid-feedback d-block">
    <div *ngIf="control?.hasError('required')" i18n="@@requiredInput">This input is required.</div>
  </div>
</div>
